// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__1I8Kg","infoBtn":"quickbooks_infoBtn__3jdBS","formBox":"quickbooks_formBox__1L9Ec","formFooter":"quickbooks_formFooter__DfAaj"};